import React from 'react';
import './gameUi.css';
import {getPlayerColorStyle} from '../../utils/gameUi/getPlayerColorStyle';
import {joinClassNames} from './joinClassNames';

export const GAME_BUTTON_VARIANTS = Object.freeze({
  NEUTRAL: 'neutral', // обычное действие — базальт
  PHASE: 'phase', // действие фазы — эмаль цвета фазы
  MINE: 'mine', // «мое» (завершить этап) — эмаль цвета игрока
  SUNK: 'sunk', // утопленная служебная кнопка в футере
});

export const GAME_BUTTON_SIZES = Object.freeze({
  MEDIUM: 'medium',
  ICON: 'icon', // квадратная 46px под одну иконку
  WIDE: 'wide', // на всю ширину контейнера
});

/**
 * Кнопка дизайн-системы матча. Недоступная кнопка — нативный disabled:
 * клик не доходит до onClick, вид — матовая плита без фаски
 * @param {string} [variant] - GAME_BUTTON_VARIANTS
 * @param {string} [size] - GAME_BUTTON_SIZES
 * @param {boolean} [pressed] - показать нажатое состояние (переключатели)
 * @param {string} [playerColor] - цвет игрока для варианта MINE
 */
export function GameButton({
  variant = GAME_BUTTON_VARIANTS.NEUTRAL,
  size = GAME_BUTTON_SIZES.MEDIUM,
  pressed = false,
  playerColor,
  type = 'button',
  className,
  style,
  children,
  ...rest
}) {
  return (
    <button
      type={type}
      className={joinClassNames(
        'gui-plate',
        'gui-button',
        variant !== GAME_BUTTON_VARIANTS.NEUTRAL && `gui-button_${variant}`,
        size !== GAME_BUTTON_SIZES.MEDIUM && `gui-button_${size}`,
        pressed && 'gui-button_pressed',
        className,
      )}
      aria-pressed={pressed || undefined}
      style={{...getPlayerColorStyle(playerColor), ...style}}
      {...rest}
    >
      {children}
    </button>
  );
}

export default GameButton;
